import { ROUTE_NAMES } from '@/constant/routes'

export default [
  {
    // Public so a signed-out colleague sees who sent the gift before signing in. The backend
    // answers 404 when the flag is off, and the page then shows the 404 page as before.
    path: '/gift/:token',
    name: ROUTE_NAMES.COLLEAGUE_GIFT_REDEEM,
    meta: { title: 'Claim your free month of Pro' },
    component: () => import(/* webpackChunkName: "colleague-gift-redeem" */ './ColleagueGiftRedeemPage.vue'),
  },
]
